import React, { FunctionComponent, useState } from 'react';
import Grid from '@mui/material/Grid';

import useParams from '../../hooks/useParams';

import LocationContainer from './LocationContainer';
import ZeroLevelSelect from './ZeroLevelSelect';

const Graph: FunctionComponent = () => {
  const params = useParams();

  const offset = parseFloat(params.get('offset') || '');
  const location = params.get('location');
  const specificity = params.get('specificity') || undefined;
  const zlselect = params.get('zlselect');

  const [zeroLevel, setZeroLevel] = useState(() => {
    if (Number.isNaN(offset)) {
      return zlselect !== null ? 0.59 : 0;
    }
    // Convert offset 59 to 0.59 for backward compatibility
    if (offset === 59) {
      return 0.59;
    }
    return offset;
  });

  const hasZLSelect = zlselect !== null;

  if (!location) {
    return (
      <div className="centered">No location provided</div>
    );
  }

  return (
    <>
      {hasZLSelect && (
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          my={2}
        >
          <ZeroLevelSelect
            value={zeroLevel}
            onChange={setZeroLevel}
          />
        </Grid>
      )}
      <LocationContainer
        location={location}
        specificity={specificity}
        offset={zeroLevel}
      />
    </>
  );
};

export default Graph;
